import React, { memo, useCallback, FC } from "react";
import DatePicker from "react-datepicker";
import FormErrorMessage from "../FormErrorMessage/FormErrorMessage";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@radix-ui/themes";

const DateRangePicker: FC<{
  name: string;
  value: any[];
  setFieldValue: (targetName: string, value: any) => Promise<void>;
  errors: any;
  isDisabled: boolean;
}> = ({ name, value, setFieldValue, errors, isDisabled }): JSX.Element => {
  const handleChange = useCallback(
    (e: any) => {
      setFieldValue(name, e);
    },
    [name, setFieldValue]
  );

  return (
    <>
      <DatePicker
        locale="en_GB"
        monthsShown={2}
        dateFormat="dd/MM/yy"
        minDate={new Date()}
        placeholderText="Select duration"
        onChange={(e: any) => {
          handleChange(e);
        }}
        selectsRange
        startDate={value[0]}
        endDate={value[1]}
        showPreviousMonths={false}
        isClearable={!isDisabled}
        disabled={isDisabled}
        customInput={
          <TextField.Root id="datepicker" variant="soft" color="gray" />
        }
      />
      {errors && errors[name] && (
        <FormErrorMessage
          text={errors[name] as string}
          isVisible={!!errors[name]}
        />
      )}
    </>
  );
};

export default memo(DateRangePicker);
